module.exports = __webpack_public_path__ + "media/images/home-page/1-3@2x-c775146e4921060ffc74015277e0f2fa.png";